import instance from ".";
import { API_ENDPOINTS } from "../utils/constants";

export const getSetting = () => {
  return instance.get(API_ENDPOINTS.setting.get);
}

export const setPushMarketing = (pushMarketing) => {
    return instance.post(API_ENDPOINTS.setting.setPushMarketing, {
        pushMarketing
    });
};

export const setPushNotice = (pushNotice) => {
    return instance.post(API_ENDPOINTS.setting.setPushNotice, {
        pushNotice
    });
};